__turbopack_context__.v({
  "Arrow": "Select-module__KCyVAW__Arrow",
  "ArrowFill": "Select-module__KCyVAW__ArrowFill",
  "ArrowInnerStroke": "Select-module__KCyVAW__ArrowInnerStroke",
  "ArrowOuterStroke": "Select-module__KCyVAW__ArrowOuterStroke",
  "Item": "Select-module__KCyVAW__Item",
  "ItemIndicator": "Select-module__KCyVAW__ItemIndicator",
  "ItemIndicatorIcon": "Select-module__KCyVAW__ItemIndicatorIcon",
  "ItemText": "Select-module__KCyVAW__ItemText",
  "Popup": "Select-module__KCyVAW__Popup",
  "ScrollArrow": "Select-module__KCyVAW__ScrollArrow",
  "Select": "Select-module__KCyVAW__Select",
  "SelectIcon": "Select-module__KCyVAW__SelectIcon",
});
